import { RouteRecordRaw } from 'vue-router';
import { RouterView } from 'vue-router';

export const mdmRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('../pages/_layout/MdmLayout.vue'), // enthält <RouterView/>
    // meta: { scope: 'mdm', title: 'Master Data Management' },
    children: [
      { path: '', name: 'home', component: () => import('../pages/Dashboard.vue') },

      {
        path: 'articles',
        component: RouterView,
        children: [
          { path: '', name: 'mdm.articles', component: () => import('../pages/articles/ArticleView.vue') },
          { path: 'create', name: 'mdm.articles.create', component: () => import('../pages/articles/CreateArticleView.vue') },
          { path: 'import', name: 'mdm.articles.import', component: () => import('../pages/articles/ImportArticles.vue') },
          { path: 'details/:id', name: 'mdm.articles.details', component: () => import('../pages/articles/DetailsArticleView.vue'), props: true },
          { path: 'edit/:id', name: 'mdm.articles.edit', component: () => import('../pages/articles/EditArticleView.vue'), props: true },
          { path: 'units', name: 'mdm.articles.units', component: () => import('../pages/articles/UnitView.vue') },
          {
            path: 'templates',
            component: RouterView,
            children: [
              { path: '', name: 'mdm.articles.templates', component: () => import('../pages/articles/templates/TemplateArticleView.vue') },
              {
                path: 'details/:id',
                name: 'mdm.articles.templates.details',
                component: () => import('../pages/articles/templates/DetailsTemplateArticleView.vue'),
                props: true,
              },
              {
                path: 'edit',
                name: 'mdm.articles.templates.edit',
                component: () => import('../pages/articles/templates/EditTemplateArticleView.vue'),
                props: (route) => ({ id: route.query.id }),
              },
            ],
          },
        ],
      },

      // Tags
      { path: 'tags', name: 'mdm.tags', component: () => import('../pages/tags/TagView.vue') },
    ],
  },
];
